import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
//import { SearchItem } from '../../../core/components/search/search.component';

@Component({
  selector: 'tt-order-line-credit',
  templateUrl: './order-line-credit.component.html',
  styleUrls: ['./order-line-credit.component.css']
})
export class OrderLineCreditComponent implements OnInit {
    orderLineKeyno;

    public edit?: Edit;

    public selectListCauses: Item[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public saving = false;

    public approving = false;

    public orderButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.edit!.order_internal_no ?? '' }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.orderLineKeyno = this.stateService.getStateParams()['orderline_keyno'];
    }

    private async loadEdit() {
        if (!!this.orderLineKeyno) {
            this.edit = (await this.datatask.Post(2758, { argtype: this.orderLineKeyno }))[0];
        }
    }

    private async loadCauses() {
        this.selectListCauses = await this.datatask.Post(2762);
    }

    private async loadStockPlaces() {
        if (!this.edit) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({
            businessco_no: this.edit.businessco_no,
            businesssite_keyno: this.edit.businesssite_keyno
        });
    }

    //public searchStockLocationNameTos = () => {
    //    return this.datatask.Post(1029, {
    //        stocklocation_name_search: this.edit?.stocklocation_name_to ?? '',
    //        stockplace_id: this.edit!.stockplace_id_to
    //    });
    //}

    //public onStockLocationNameToSelected(item?: StockLocationSearchItem) {
    //    if (!!this.edit) {
    //        this.edit.stocklocation_keyno_to = item?.item_id ?? '0';
    //        this.edit.stocklocation_name_to = item?.item_name ?? '';
    //    }
    //}

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2770, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async approveChanges() {
        if (!!this.edit) {
            try {
                this.approving = true;

                const response = (await this.datatask.Post(2771, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.approving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCauses();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    company_name: string;
    stockplace_name: string;
    stat_cust_no: string;
    cust_name: string;
    order_order_no: string;
    order_internal_no: string;
    order_date: string;
    orderline_keyno: string;
    prod_id: string;
    prod_name: string;
    ordered_quantity: string;
    delivered_quantity: string;
    orderlinecreditcause_keyno: string;
    orderlinecreditcause_description: string;
    change_possible: string;
    invoiced_quantity: string;
    h_orderlinecredit_cause: string;
    h_orderlinecredit_stocktreatment: string;
    quantity_to_stock: string;
    quantity_discarding: string;
    orderlinecredit_orderline_keyno_origin: string;
    stockplace_id_to: string;
    businessco_no: string;
    floating_location: string;
    stocklocation_keyno_to: string | number;
    stocklocation_name_to: string;
    businesssite_keyno: string;
}

//interface StockLocationSearchItem {
//    stocklocation_keyno: string;
//    stocklocation_name: string;
//    orderby: string;
//    item_id: string | number;
//    item_name: string;
//}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCredit', {
//        templateUrl: 'views/components/views/orderLineCredit/orderLineCredit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'orderLineCreditService', 'logisticService', 'typeaheadService', 'translateService', function ($stateParams, stateService, utilityService, modalService, orderLineCreditService, logisticService, typeaheadService, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineKeyno = $stateParams.orderline_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                orderButtons: [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no }) }],
//                edit: {},
//                selectListCauses: [],
//                selectListStockPlaces: [],
//                lockedSave: false,
//                lockedApprove: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await orderLineCreditService.getOrderLineCredit({ orderline_keyno: orderLineKeyno }))[0];
//            }

//            async function loadCauses() {
//                vm.model.selectListCauses = await orderLineCreditService.listOrderLineCreditCauses();
//            }

//            async function loadStocks() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.businesssite_keyno, true) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({
//                    businessco_no: vm.model.edit.businessco_no,
//                    businesssite_keyno: vm.model.edit.businesssite_keyno
//                });
//            }

//            function retrieveStockPlace() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_to, true) !== true) return;

//                return logisticService.getStockPlace({ stockplace_id: vm.model.edit.stockplace_id_to }).then(function (response) {
//                    vm.model.edit.floating_location = response[0].floating_location;
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'stocklocation_name_to':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.lookUpStockLocations({
//                            stocklocation_name_search: vm.model.edit[id] || '',
//                            stockplace_id: vm.model.edit.stockplace_id_to
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'stocklocation_name_to':
//                        if (item) {
//                            //vm.model.edit.stockplace_id_to = item?.item_id ?? '0';
//                            vm.model.edit.stocklocation_keyno_to = item?.item_id ?? '0';
//                            vm.model.edit.stocklocation_name_to = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('stocklocation_name_to');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'stocklocation_name_to':
//                        vm.model.edit.stocklocation_name_to = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                //vm.model.edit.stockplace_id_to = item.item_id;
//                                vm.model.edit.stocklocation_keyno_to = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('stocklocation_name_to');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'stocklocation_name_to':
//                        //vm.model.edit.stockplace_id_to = '0';
//                        vm.model.edit.stocklocation_keyno_to = '0';
//                        vm.model.edit.stocklocation_name_to = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'stockplace_id_to':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.stockplace_id_to) !== true) return;

//                        vm.model.edit.stockplace_id_to = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_to, true) !== true) return;

//                        retrieveStockPlace();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCreditService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        //stateService.back();		
//                    }
//                });
//            }

//            vm.approveChanges = function () {
//                vm.model.lockedApprove = true;

//                orderLineCreditService.approveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedApprove = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedApprove = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadCauses();
//                loadStocks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
